import { render } from "./batchAccountClosure.vue?vue&type=template&id=f033a712&scoped=true"
import script from "./batchAccountClosure.vue?vue&type=script&lang=js"
export * from "./batchAccountClosure.vue?vue&type=script&lang=js"

import "./batchAccountClosure.vue?vue&type=style&index=0&id=f033a712&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f033a712"

export default script